import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewNativeSoilReportComponent } from './components/native-soil/view-native-soil-report/view-native-soil-report.component';
import { ViewPrecastReportComponent } from './components/precast/view-precast-report/view-precast-report.component';
import { ThermalResistivityNativeSoilComponent } from
  './components/native-soil/thermal-resistivity-native-soil/thermal-resistivity-native-soil.component';
import { ThermalResistivityPrecastComponent } from
  './components/precast/thermal-resistivity-precast/thermal-resistivity-precast.component';
import { HistoricalCurvePointsComponent } from
  './components/precast/historical-curve-points/historical-curve-points.component';

const routes: Routes = [
  {
    path: 'view/precast/:id',
    component: ViewPrecastReportComponent,
  },
  {
    path: 'edit/precast/:id',
    component: ViewPrecastReportComponent,
  },
  {
    path: 'thermal/precast/:id',
    component: ThermalResistivityPrecastComponent,
  },
  {
    path: 'historical/precast',
    component: HistoricalCurvePointsComponent,
  },
  {
    path: 'view/nativesoil/:id',
    component: ViewNativeSoilReportComponent,
  },
  {
    path: 'edit/nativesoil/:id',
    component: ViewNativeSoilReportComponent,
  },
  {
    path: 'thermal/nativesoil/:id',
    component: ThermalResistivityNativeSoilComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule { }
